"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupServices = exports.ServiceName = exports.HostKey = void 0;
var HostKey;
(function (HostKey) {
    HostKey[HostKey["ACTIVITY"] = 0] = "ACTIVITY";
    HostKey[HostKey["IM"] = 1] = "IM";
    HostKey[HostKey["IM_FRIEND_COMMAND"] = 2] = "IM_FRIEND_COMMAND";
    HostKey[HostKey["IM_ROOM_COMMAND"] = 3] = "IM_ROOM_COMMAND";
    HostKey[HostKey["IM_FRIEND_QUERY"] = 4] = "IM_FRIEND_QUERY";
    HostKey[HostKey["IM_OTHER_COMMAND"] = 5] = "IM_OTHER_COMMAND";
    HostKey[HostKey["IM_OTHER_QUERY"] = 6] = "IM_OTHER_QUERY";
    HostKey[HostKey["IM_MESSAGE_COMMAND"] = 7] = "IM_MESSAGE_COMMAND";
    HostKey[HostKey["IM_AUTH_COMMAND"] = 8] = "IM_AUTH_COMMAND";
    HostKey[HostKey["IM_USER_COMMAND"] = 9] = "IM_USER_COMMAND";
    HostKey[HostKey["IM_USER_QUERY"] = 10] = "IM_USER_QUERY";
    HostKey[HostKey["IM_BUSINESS_COMMAND"] = 11] = "IM_BUSINESS_COMMAND";
    HostKey[HostKey["IM_BUSINESS_QUERY"] = 12] = "IM_BUSINESS_QUERY";
    HostKey[HostKey["IM_NOTIFY_QUERY"] = 13] = "IM_NOTIFY_QUERY";
    HostKey[HostKey["IM_NOTIFY_COMMAND"] = 14] = "IM_NOTIFY_COMMAND";
    HostKey[HostKey["JPOINT"] = 15] = "JPOINT";
    HostKey[HostKey["PAN"] = 16] = "PAN";
    HostKey[HostKey["PAY"] = 17] = "PAY";
    HostKey[HostKey["FORUM_MATERIAL_QUERY"] = 18] = "FORUM_MATERIAL_QUERY";
    HostKey[HostKey["FORUM_MATERIAL_COMMAND"] = 19] = "FORUM_MATERIAL_COMMAND";
    HostKey[HostKey["FORUM_MEDAL_QUERY"] = 20] = "FORUM_MEDAL_QUERY";
    HostKey[HostKey["FORUM_MEDAL_COMMAND"] = 21] = "FORUM_MEDAL_COMMAND";
    HostKey[HostKey["FORUM_FURNACE_COMMAND"] = 22] = "FORUM_FURNACE_COMMAND";
    HostKey[HostKey["FORUM_ARTIFACT_QUERY"] = 23] = "FORUM_ARTIFACT_QUERY";
    HostKey[HostKey["FORUM_ARTIFACT_COMMAND"] = 24] = "FORUM_ARTIFACT_COMMAND";
    HostKey[HostKey["FORUM_JKF_STATUS_QUERY"] = 25] = "FORUM_JKF_STATUS_QUERY";
    HostKey[HostKey["FORUM_JKF_STATUS_COMMAND"] = 26] = "FORUM_JKF_STATUS_COMMAND";
    HostKey[HostKey["FORUM_SEARCH"] = 27] = "FORUM_SEARCH";
})(HostKey = exports.HostKey || (exports.HostKey = {}));
var ServiceName;
(function (ServiceName) {
    ServiceName[ServiceName["SERVICE_TALK"] = 0] = "SERVICE_TALK";
})(ServiceName = exports.ServiceName || (exports.ServiceName = {}));
exports.groupServices = {
    // TALK ALL service
    [ServiceName[ServiceName.SERVICE_TALK]]: [
        HostKey[HostKey.IM_FRIEND_COMMAND],
        HostKey[HostKey.IM_FRIEND_QUERY],
        HostKey[HostKey.IM_ROOM_COMMAND],
        HostKey[HostKey.IM_MESSAGE_COMMAND],
        HostKey[HostKey.IM_AUTH_COMMAND],
        HostKey[HostKey.IM_USER_COMMAND],
        HostKey[HostKey.IM_OTHER_COMMAND],
        HostKey[HostKey.IM_OTHER_QUERY],
        HostKey[HostKey.IM_USER_QUERY],
        HostKey[HostKey.IM_BUSINESS_COMMAND],
        HostKey[HostKey.IM_BUSINESS_QUERY],
        HostKey[HostKey.IM_NOTIFY_COMMAND],
        HostKey[HostKey.IM_NOTIFY_QUERY],
    ]
};
